import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得先前申請 地址/電話/email 記錄
export function getInfoBCBD(code) {
    return get(`${url}/${code}/info`);
}

// 取得選單資訊-縣市/鄉鎮
export function getCityInfo(code) {
    return get(`${url}/${code}/cityInfo`);
}
// 取得選單資訊-手機國碼
export function getMobileCodeInfo(code) {
    return get(`${url}/${code}/mobileCodeInfo`);
}

// 送出bc變更資料
export function submitBCBD(code, data) {
    return post(`${url}/${code}/submit`, data, { ...options, errorDialog: false, repeatRequestCancel: true });
}

// 保全聯盟鍊
// 保全聯盟鏈同意條款資料
export function getAgreeTermsBCBD(code) {
    return get(`${url}/${code}/getAgreeTerms`);
}
// 保全聯盟鏈資料
export function getAllianceChain(code) {
    return get(`${url}/${code}/allianceChain`);
}
// 選取公會聯盟鏈公司資料
export function getLiaCompany() {
    return get(`${url}/alliance/getCompanyBylia`);
}
// 送出所選取之公司資訊
export function submitAllianceChain(code, data) {
    return post(`${url}/${code}/submitAllianceChain`, data);
}
